import script from "./ClientConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./ClientConfirmation.vue?vue&type=style&index=0&id=da406be2&lang=css"

const __exports__ = script;

export default __exports__